import React from 'react';

const ActiveIcon = () => {
  return (
    <div className="vbz-icon-beneficiaries">
      <div className="vbz-icon-beneficiaries-active" />
    </div>
  );
};

export default ActiveIcon;
